import React, { useEffect, useState } from 'react';
import { Box, Flex, IconButton, Text,useToast } from '@chakra-ui/react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ACCOUNTS_URL } from '../../../../Globalapi/Globalapi';

const List = () => {
  const [partyList, setPartyList] = useState([]);
  const cmp_id = sessionStorage.getItem('cmp_id'); // Replace with actual `cmp_id` from your session or context
  const navigate = useNavigate();
  const toast= useToast()
  useEffect(() => {
    const fetchPartyList = async () => {
      try {
        const response = await axios.post(`${ACCOUNTS_URL}/party/list_all_party.php`, {
          cmp_id: cmp_id,
          party_type: 1, // Adjust as needed for customer or supplier
        });

        if (response.data.status === 'success') {
          setPartyList(response.data.data);
        } else {
          console.error('No records found');
        }
      } catch (error) {
        console.error('Error fetching party list:', error);
      }
    };

    fetchPartyList();
    const interval = setInterval(fetchPartyList, 1000);

    // Clear interval on component unmount
    return () => clearInterval(interval);
  }, [cmp_id]);

  const handleDelete = async (partyId) => {
    try {
      const response = await axios.post(`${ACCOUNTS_URL}/party/delete_party.php`, {
        party_id: partyId,
        cmp_id: cmp_id,
      });
  
      if (response.data.success) {
        setPartyList(partyList.filter((party) => party.p_id !== partyId));
        toast('Party deleted successfully');
      } else {
        toast('Failed to delete party');
      }
    } catch (error) {
      console.error('Error deleting party:', error);
      toast('Error deleting party');
    }
  };
  

  return (
    <Box>
      {partyList.map((party) => (
        <Flex
          key={party.p_id}
          justify="space-between"
          align="center"
          p={3}
          borderBottom="1px solid #e2e8f0"
          _hover={{ bg: 'gray.100' }}
        >
          <Box>
            <Text fontWeight="bold">{party.L_name}</Text>
            <Text fontSize="sm" color="gray.500">
              {party.led_group_name}
            </Text>
          </Box>
          <Flex>
            <IconButton
              icon={<FaEdit />}
              aria-label="Edit party"
              mr={2}
              onClick={() => {
                sessionStorage.setItem('p_id', party.p_id);
                navigate('/party/customer/edit'); // Navigate to the desired route
              }}
            />

            <IconButton
              icon={<FaTrash />}
              aria-label="Delete party"
              bg="none"
              color='red'
              onClick={() => handleDelete(party.p_id)}
            />
          </Flex>
        </Flex>
      ))}
    </Box>
  );
};

export default List;
